import { Badge } from '@chakra-ui/react';
import type { SentimentDisposition } from '../../../types/lobbyDay'

export const DISPOSITION_META: Record<SentimentDisposition, { label: string; colorScheme: string }> = {
  Excited: { label: '✅ Voted With Us', colorScheme: 'green' },
  Jilted: { label: '➖ No Support', colorScheme: 'orange' },
  Betrayed: { label: '⚠️ Broke Promise', colorScheme: 'red' },
  Pending: { label: '⏳ Pending', colorScheme: 'gray' },
}

export function DispositionChip({ disposition }: { disposition: SentimentDisposition }) {
  const meta = DISPOSITION_META[disposition]
  return <Badge colorPalette={meta.colorScheme}>{meta.label}</Badge>;
}
